import { fShortenNumber } from '@/utils/format-number';

import { Box, Chip, Avatar, Typography } from '@mui/material';

import { SocialIcon } from 'src/components/iconify';

export default function FacebookPagesSection({socialAccounts}) {
  
  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SocialIcon width={24} icon="facebook" />
          Facebook Pages
        </Typography>
      </Box>

      {socialAccounts && socialAccounts?.pages?.length > 0 ? (
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
            Connected Pages ({socialAccounts.pages.length})
          </Typography>
          {socialAccounts.pages.map((page) => (
            <Box
              key={page.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 2,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                mb: 1,
              }}
            >
              <Avatar src={page?.picture?.data?.url} alt={page.name} sx={{ width: 48, height: 48 }}>
                {page.name?.charAt(0)?.toUpperCase()}
              </Avatar>
              <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  {page.name}
                </Typography>
                {page?.category && <Typography variant="body2" color="text.secondary">
                  {page.category}
                </Typography>}
                {page?.fan_count && <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                  <Typography variant="caption">
                    {fShortenNumber(page.fan_count)} followers
                  </Typography>
                  <Typography variant="caption">ID: {page.id}</Typography>
                </Box>}
              </Box>
              {page.verification_status && <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Chip label="Facebook Page" size="small" variant="outlined" />
                {page.verification_status === 'blue_verified' && (
                  <Chip label="Verified" size="small" color="primary" />
                )}
              </Box>}
            </Box>
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            p: 3,
            textAlign: 'center',
            backgroundColor: 'grey.50',
            borderRadius: 1,
            border: '1px dashed',
            borderColor: 'grey.300',
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            No Facebook Pages found
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Connect your Facebook account to manage your pages.
          </Typography>
        </Box>
      )}
    </Box>
  );
}
